import { render, staticRenderFns } from "./StudentForm.vue?vue&type=template&id=b64439ea"
import script from "./StudentForm.vue?vue&type=script&lang=js"
export * from "./StudentForm.vue?vue&type=script&lang=js"
import style0 from "./StudentForm.vue?vue&type=style&index=0&id=b64439ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports